export const SDKVersion = '0.1'
export const SDKNumVersion = SDKVersion.split( '.' ).map( ( v, i ) => parseInt( v ) * Math.pow( 10, 2 - i ) ).reduce( ( acc, v ) => acc + v, 0 ) // 101
